import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import LabelsMenu from '../components/labels/LabelsMenu.vue';
import LabelsList from '../components/labels/LabelsList.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'LabelsView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LabelsMenu),
    _createVNode(LabelsList)
  ], 64))
}
}

})